// extracted by mini-css-extract-plugin
export default {"root":"Stepper_root__3tj0L","list":"Stepper_list__gnA1M","step":"Stepper_step__l3-UI","stepActive":"Stepper_stepActive__oToky","panel":"Stepper_panel__2u44L"};